
import React from 'react';

export default function CEOMessageSection() {
  const companyInfo = [
    { label: '商号', value: 'ナインバレー株式会社' },
    { label: '所在地', value: '〒753-0056 山口県山口市湯田温泉2丁目4-26' },
    { label: '設立', value: '2019年9月2日' },
    { label: '代表者', value: '代表取締役 九谷 直樹' },
    { label: '資本金', value: '100万円' },
    { label: '事業内容', value: '宿泊業（光のアート型グランピング施設の運営）\nマーケティング支援（ローカルマーケティングラボ）' },
    { label: 'URL', value: 'https://www.redondo.jp/' },
    { label: '企業理念', value: '「私たちは相互依存と能動的思考で人の成長を支えます」' }
  ];

  return (
    <section className="py-16 md:py-24 bg-white mb-16 md:mb-24">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-20">
            <p className="text-sm font-medium uppercase tracking-wider mb-4 md:mb-6" style={{ color: 'rgb(11, 61, 145)' }}>
              CEO MESSAGE
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-8 md:mb-16 leading-relaxed">
              代表者挨拶
            </h2>
            <p className="text-lg md:text-xl text-gray-600 leading-loose">
              地域の価値を再編集し、持続可能な未来を創造します
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center mb-12 md:mb-20">
            <div className="order-2 lg:order-1">
              <div className="space-y-6 md:space-y-8">
                <div>
                  <h3 className="text-xl md:text-2xl font-bold text-[#111827] mb-3 md:mb-4 leading-relaxed">
                    代表取締役社長　九谷直樹
                  </h3>
                  <p className="text-gray-500 mb-6 md:mb-8">
                    ナインバレー株式会社
                  </p>
                </div>

                <div className="prose prose-lg text-gray-600 space-y-4 md:space-y-6">
                  <p className="text-sm md:text-base leading-loose">
                    この度は、ナインバレー株式会社のホームページをご覧いただき、誠にありがとうございます。
                  </p>
                  <p className="text-sm md:text-base leading-loose">
                    弊社は山口の地に根ざし、お客様との信頼関係を大切にしながら事業を展開してまいりました。私たちが目指すのは、単なるサービスの提供ではなく、お客様の課題解決のパートナーとして、真に価値のあるソリューションをお届けすることです。
                  </p>
                  <p className="text-sm md:text-base leading-loose">
                    変化の激しい現代において、企業には常に新しい発想と柔軟な対応力が求められています。その中で私たちナインバレーは、相互依存と能動的思考で人の成長を支える企業でありたいと考えております。
                  </p>
                  <p className="text-sm md:text-base leading-loose">
                    地域の皆様、そして全国のお客様から信頼していただける企業として、私たち一人ひとりが持てる力を最大限に発揮し、お客様の成功に貢献できるよう全力で取り組んでまいります。
                  </p>
                </div>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <div className="relative">
                <div className="relative overflow-hidden rounded-2xl shadow-lg">
                  <img 
                    src="https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/8347473296e7e2dcba146a2cda6272f9.jfif"
                    alt="代表取締役社長　九谷直樹"
                    className="w-full h-auto object-cover"
                  />
                  
                  {/* 装飾的なグラデーションオーバーレイ */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                </div>

                {/* 背景装飾 */}
                <div className="absolute -top-4 -right-4 w-20 h-20 md:w-24 md:h-24 bg-[#40BFB4]/10 rounded-full blur-2xl"></div>
                <div className="absolute -bottom-4 -left-4 w-24 h-24 md:w-32 md:h-32 bg-[#0B3D91]/10 rounded-full blur-2xl"></div>
              </div>
            </div>
          </div>

          {/* 会社概要 */}
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <p className="text-sm font-medium uppercase tracking-wider mb-4 md:mb-6" style={{ color: 'rgb(11, 61, 145)' }}>
                COMPANY OVERVIEW
              </p>
              <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-[#111827] mb-6 md:mb-8 leading-relaxed">
                会社概要
              </h3>
            </div>

            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              {companyInfo.map((info, index) => (
                <div 
                  key={index} 
                  className={`grid grid-cols-1 md:grid-cols-3 ${index !== companyInfo.length - 1 ? 'border-b border-gray-100' : ''}`}
                >
                  <div className="bg-gray-50 px-4 md:px-6 py-4 md:py-5 font-medium text-[#111827] text-sm md:text-base">
                    {info.label}
                  </div>
                  <div className="md:col-span-2 px-4 md:px-6 py-4 md:py-5 text-gray-600 leading-loose text-sm md:text-base">
                    {info.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
